import React from 'react';
import {useHistory} from 'react-router-dom/cjs/react-router-dom';

import {routes} from '../../../../util/uiconstants';

import Button from '../../../CoreWrappers/Button';
import StyledControls from './StyledControls';

const Controls = ({values, errors, handleChange, handleSubmit, handleReset, isFormValid, labels}) => {
	const history = useHistory();

	const renderButton = (btnProps) => {
		const props = {
			...btnProps
		};

		return <Button {...props} />;
	};

	const saveProps = {
		label: labels.save,
		size: "medium",
		onClick: () =>
			handleSubmit(() => history.push(`/${routes.project.root}`, null))
	};

	const cancelProps = {
		label: labels.cancel,
		variant: 'ghost',
		size: "medium",
		onClick: () => history.push(`/${routes.project.root}`, null)
	};

	return (
		<StyledControls>
			{renderButton(cancelProps)}
			{renderButton(saveProps)}
		</StyledControls>
	);
};

export default Controls;
